import { render, staticRenderFns } from "./SimulationsDetailsTab.vue?vue&type=template&id=3d07333e&scoped=true&"
import script from "./SimulationsDetailsTab.vue?vue&type=script&lang=js&"
export * from "./SimulationsDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d07333e",
  null
  
)

export default component.exports